import { createStore } from 'vuex'
import { auth } from './modules/auth'
import { globalSearch } from './modules/globalSearch'

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    globalSearch
  }
})
